import React from 'react';

import ClassroomContext from './context';

export const useClassroomContext = () => {
  const context = React.useContext(ClassroomContext);
  if (context === undefined) {
    throw new Error('useClassroomContext must be used within a ClassroomProvider');
  }
  return context;
};
